/* Keeps the .variant-option__swatch-value span in the shade fieldset's
   <legend> in sync with the selected chip.

   The span is rendered by snippets/variant-main-picker.liquid. Horizon
   only emitted it for options carrying real Shopify swatch data, which
   these CSS-coloured chips don't use, and it never updated on selection
   change regardless. */
(function () {
  function sync(input) {
    if (!input) return;
    var fieldset = input.closest('.variant-option--buttons');
    if (!fieldset) return;
    var valueEl = fieldset.querySelector('.variant-option__swatch-value');
    if (!valueEl) return;
    // Blend shades are named "Vanilla (Blend)" in the catalogue; drop
    // just the brackets so they read "Vanilla Blend". Mirrors the same
    // replace in snippets/variant-main-picker.liquid.
    valueEl.textContent = input.value.replace(/[()]/g, '');
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio') return;
    if (!t.closest('.variant-picker .variant-option--buttons')) return;
    sync(t);
  });

  // Also run once on load in case the checked radio isn't the one
  // Liquid picked as selected_value.
  document.addEventListener('DOMContentLoaded', function () {
    document
      .querySelectorAll('.variant-picker .variant-option--buttons input[type="radio"]:checked')
      .forEach(sync);
  });
})();
